import { Flex, Icons, Typography } from 'components';
import { ReactElement } from 'react';
import styled from 'styled-components';

interface ButtonActivationProps {
  isActive: boolean;
}

const Icon = styled(Icons)(({ theme }) => {
  return `
        color: ${theme.colors.white};
        width: 22px;
      `;
});

const ButtonActivation = ({ isActive }: ButtonActivationProps): ReactElement => {
  return (
    <Flex
      borderRadius={32}
      backgroundColor={isActive ? 'primary_400' : 'light4'}
      justifyContent="space-between"
      alignItems="center"
      paddingX="16px"
      paddingY="8px"
    >
      <Typography fontWeight="bold" color="white">
        {isActive ? 'Ativo' : 'Ainda não está ativado'}
      </Typography>
      {isActive ? (
        <Flex paddingLeft={16}>
          <Icon icon="check" />
        </Flex>
      ) : null}
    </Flex>
  );
};

export default ButtonActivation;
